'use strict';

const toastHelpers = require('core/components/toast');

var sizeRecommender = {};

// State management to prevent race conditions
var modalState = {
    isProcessing: false,
    redirectInProgress: false,
    modalOpen: false,
    messageListener: null,
    cleanup: function() {
        this.isProcessing = false;
        this.redirectInProgress = false;
        this.modalOpen = false;

        // Remove message listener if it exists
        if (this.messageListener) {
            window.removeEventListener('message', this.messageListener);
            this.messageListener = null;
        }
    }
};

function registerUser(data, url) {
    // Prevent multiple simultaneous registration attempts
    if (modalState.isProcessing) {
        return;
    }

    modalState.isProcessing = true;
    var $modal = $('#workfitterEmailModal');
    var $error = $modal.find('.wf-login-mismatch');
    var productId = $('.product-detail').attr('data-pid');

    $error.text('').hide();
    data.currentURL = window.location.href;
    data.productId = productId;
    $.ajax({
        type: 'GET',
        url: url,
        data: data,
        success: function(response) {
            modalState.isProcessing = false;
            if (response.loggedInSessionExpired) {
                // If user is no longer logged in, show them the guest email field entry w/ error message
                $error.text(response.expiredMessage).show();
                $modal.modal('show');
                $.spinner().stop();
            } else if (response.redirectURL) {
                // Show the iframe modal instead of opening a new window
                showWorkfitterIframe(response.redirectURL);
            } else if (response.recommendations && response.recommendations.length > 0) {
                // User has recommendations - update the UI
                $modal.modal('hide');
                updateRecommendationsUI(response.recommendations);
                $.spinner().stop();
            } else {
                // otherwise, throw general error
                $modal.modal('hide');
                toastHelpers.methods.show('danger', response.generalError, true);
                $.spinner().stop();
            }
        },
        error: function(error) {
            modalState.isProcessing = false;
            console.error(error);
            $.spinner().stop();
        }
    });
}

function showWorkfitterIframe(redirectURL) {
    // Prevent opening modal if already open or redirect in progress
    if (modalState.modalOpen || modalState.redirectInProgress) {
        return;
    }

    modalState.modalOpen = true;
    var $iframeModal = $('#workfitterIframeModal');
    var $iframe = $('#workfitterIframe');

    // Set iframe source but keep it hidden initially
    $iframe.attr('src', redirectURL).hide();

    // Show loading overlay immediately to cover any flashing
    showLoadingOverlay();

    // Hide any existing modals
    $('#workfitterEmailModal').modal('hide');

    // Show iframe modal
    $iframeModal.modal('show');
    // Stop spinner
    $.spinner().stop();

    // Add event listeners for iframe communication
    setupIframeListeners();
}

function setupIframeListeners() {
    var $iframe = $('#workfitterIframe');

    // Reset redirect state
    modalState.redirectInProgress = false;

    // Clean up any existing message listener
    if (modalState.messageListener) {
        window.removeEventListener('message', modalState.messageListener);
    }

    // Create new message listener and store reference for cleanup
    modalState.messageListener = function(event) {
        // Check if the message is from the workfitter iframe
        if (event.source === document.getElementById('workfitterIframe').contentWindow) {
            handleIframeMessage(event);
        }
    };

    // Listen for messages from the iframe - this is our primary completion mechanism
    window.addEventListener('message', modalState.messageListener);

    // Simple load handler to show iframe after initial load
    $iframe.one('load', function() {
        // Show iframe after first load and hide loading overlay
        $iframe.show();
        hideLoadingOverlay();
    });
}

function handleIframeMessage(event) {
    var data = event.data;

    // Handle workfitter completion message
    if (data && typeof data === 'object' && data.type === 'workfitter_complete') {
        // Close modal immediately and redirect to return URL
        $('#workfitterIframeModal').modal('hide');
        $.spinner().start();

        setTimeout(function() {
            if (data.returnUrl) {
                window.location.href = data.returnUrl;
            } else {
                window.location.reload();
            }
        }, 5000);
    }
}

function showLoadingOverlay() {
    $('.workfitter-loading-overlay').addClass('show');
}

function hideLoadingOverlay() {
    $('.workfitter-loading-overlay').removeClass('show');
}

function updateRecommendationsUI(recommendations) {
    var $recommender = $('.workfitter-size-recommender');
    var $button = $recommender.find('.wf-find-size');

    var recommendationsHTML = '<div class="size-recommendations">';

    recommendations.forEach(function(rec) {
        if (rec.key && rec.key.toUpperCase() === 'SIZE') {
            recommendationsHTML += '<span class="size-recommendation">' + rec.key + ': ' + rec.value + '</span>';
        }
    });

    recommendations.forEach(function(rec) {
        if (rec.key && rec.key.toUpperCase() !== 'SIZE') {
            recommendationsHTML += '<span class="size-recommendation">' + rec.key + ': ' + rec.value + '</span>';
        }
    });

    recommendationsHTML += '</div>';

    $button.replaceWith(recommendationsHTML);
}

function closeWorkfitterModal() {
    $('#workfitterIframeModal').modal('hide');

    // Reset iframe source and make sure it's visible for next time
    $('#workfitterIframe').attr('src', 'about:blank').show();

    // Clean up all event listeners and state
    $(window).off('beforeunload.workfitter');
    $('#workfitterIframe').off('load beforeload');
    modalState.cleanup();

    // Hide loading overlay if shown
    hideLoadingOverlay();
}


sizeRecommender.init = function () {
    $('body').on('click', '.wf-find-size', function () {
        var $btn = $(this);
        var $container = $('.workfitter-size-recommender');
        var url = $btn.data('url');
        var isLoggedIn = $btn.data('isloggedin');
        var data = {
            isLoggedIn: isLoggedIn
        };

        if (isLoggedIn) {
            $container.spinner().start();
            registerUser(data, url);
        } else {
            // Show guest user email input
            $('#workfitterEmailModal').modal('show');
        }
    });

    $('body').on('submit', '#workfitterEmailModal .wf-modal-form', function (e) {
        e.preventDefault();
        var $modal = $('#workfitterEmailModal');
        var $form = $modal.find('form');
        var url = $form.attr('action');
        var userID = $form.find('.wf-guest-email').val();
        var data = {
            isLoggedIn: false,
            userID: userID
        };

        if ($form[0].checkValidity()) {
            $modal.spinner().start();
            registerUser(data, url);
        }
    });

    $('body').on('click', '#workfitterEmailModal .wf-modal-submit', function (e) {
        e.preventDefault();
        $('.wf-modal-form').trigger('submit');
    });

    // Handle iframe modal close
    $('body').on('click', '.wf-iframe-close', function () {
        closeWorkfitterModal();
    });


    // Handle iframe modal hidden event
    $('#workfitterIframeModal').on('hidden.bs.modal', function () {
        // Reset iframe source when modal is closed and make sure it's visible for next time
        $('#workfitterIframe').attr('src', 'about:blank').show();

        // Clean up all event listeners and state
        $(window).off('beforeunload.workfitter');
        $('#workfitterIframe').off('load beforeload');
        modalState.cleanup();

        // Hide loading overlay if shown
        hideLoadingOverlay();
    });
};

module.exports = sizeRecommender;
